import React from "react"
import { Chip } from "@mui/material"
import { getPSEColorByStatus } from "../../../utils/productionStepExecution"

const statusColors = {
	TODO: { color: "#1E86E5", border: "1px solid #90C9F9" },
	LOCKED: { color: "#555", border: "1px solid #CCC" },
	IN_PROGRESS: { color: "#B38616", border: "1px solid #F2C046" },
	DONE: { color: "#368F50", border: "1px solid #89D69F" },
	FAIL: { color: "#368F50", border: "1px solid #89D69F" },
	SUCCESS: { color: "#368F50", border: "1px solid #89D69F" },
	TO_TEST: { color: "#7900D9", border: "1px solid #B389FF", backgroundColor: "#F1E7FF" },
	LATE: { color: "#CC0030", border: "1px solid #F1959F" }, // Not exists yet?
	VEILLE: { color: "#607FE0", border: "1px solid #607FE0" }, // Overnight PSE indicator
	CANCELLED: { color: "#CC0030", border: "1px solid #F1959F" }, // Maybe changed later
}

const chipSx ={
	root: {
		display: "flex",
		height: 24,
		padding: "4px 8px",
		justifyContent: "center",
		alignItems: "center",
		gap: "4px",
		borderRadius: "999999px",
		fontSize: 16,
		fontStyle: "normal",
		lineHeight: 1.5,
		fontWeight: 400,
		"& .MuiChip-label": {
			paddingLeft: 0,
			paddingRight: 0
		}
	}
}

const PSEStatusChip = ({ statusValue, statusName, sx = {} }) => {
	const palette = getPSEColorByStatus(statusValue)
	
	return (
		<Chip
			label={statusName}
			status={statusValue}
			variant="outlined"
			sx={{
				...chipSx.root,
				...statusColors[statusValue],
				border: `1px solid ${palette.dark}`,
				backgroundColor: statusColors[statusValue].backgroundColor || "#FFFFFF",
				...sx
			}}
		/>
	)
}

export default PSEStatusChip
